const cache = {};
export async function cachedRequest(key, func) {
    if (!cache[key]) {
        cache[key] = await func();
    }
    return cache[key];
}
//# sourceMappingURL=cached-request.js.map